import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Router } from '@angular/router';
import {AuthService} from '../../utility/auth-service';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private router: Router,private authService:AuthService) {}

    canActivate() {
        if (localStorage.getItem('isLoggedin')) {
            return true;
        }
        this.authService.removeSession();
        this.router.navigate(['/login']);
        return false;
    }
}
